import { api } from './auth.service';

const alocacaoService = {
  // Calcula preview (não persiste)
  calcular: async (params) => {
    const r = await api.post('/alocacoes/calcular', params);
    return r.data;
  },

  // Calcula + persiste
  aplicar: async (params) => {
    const r = await api.post('/alocacoes/aplicar', params);
    return r.data;
  },

  // Atualizar (mover/redimensionar) bloco
  atualizar: async (id, dados) => {
    const r = await api.put(`/alocacoes/${id}`, dados);
    return r.data;
  },

  // Excluir bloco (soft delete)
  excluir: async (id) => {
    const r = await api.delete(`/alocacoes/${id}`);
    return r.data;
  },

  // Listar alocações de um colaborador num intervalo
  listarColaborador: async (colaboradorId, { inicio, fim, tipo } = {}) => {
    const params = new URLSearchParams();
    if (inicio) params.append('inicio', inicio);
    if (fim)    params.append('fim',    fim);
    if (tipo)   params.append('tipo',   tipo);
    const qs = params.toString();
    const r = await api.get(`/alocacoes/colaborador/${colaboradorId}${qs ? '?' + qs : ''}`);
    return r.data;
  },
};

export default alocacaoService;
